import React, { useMemo, useRef } from 'react';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import { UIGameResourceCardsTooltipContent } from '../../../common/UIGameResourceCardsTooltipContent/index.ts';
import { getCardsForPiece } from '@colonist/game-card-types';
import { PieceTypes } from '@colonist/game-base-types';
import { useActionButtonCommonErrors } from '../utils.ts';
import { CITY_WALL_IMAGE_PATH } from '../../../utils/gamePieces.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
import { ActionState } from '@colonist/game-states';
import { useMechanicValidatorCityWall } from '../../../store/selectors/useMechanicValidatorCityWall.ts';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
const cardsToBuildCityWall = getCardsForPiece(PieceTypes.CityWall);
export const UIGameActionButtonCityWall = ({ className })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const currentStateValidator = useCurrentStateValidator();
    const { getPlayerValidator } = usePlayerValidators();
    const playerValidator = getPlayerValidator(myColor);
    const tooltipRef = useRef(null);
    const { errorHelperText, hasCommonErrors } = useActionButtonCommonErrors();
    const { sendBuildCityWall, sendCancelAction, sendClearCornerHighlight } = useGameStore((state)=>state.gameSendEvent);
    const cityWallValidator = useMechanicValidatorCityWall();
    const actionStatus = useMemo(()=>{
        if (!cityWallValidator) {
            return {
                canTakeAction: false
            };
        }
        const canPlaceCityWallActionStatus = cityWallValidator.canPlayerPlaceCityWall(myColor);
        return canPlaceCityWallActionStatus;
    }, [
        cityWallValidator,
        myColor
    ]);
    const triggerFlickerCardsAnimation = ()=>{
        const notEnoughResources = !playerValidator.hasResourceCardsInHand(cardsToBuildCityWall);
        if (notEnoughResources) {
            var _tooltipRef_current;
            (_tooltipRef_current = tooltipRef.current) === null || _tooltipRef_current === void 0 ? void 0 : _tooltipRef_current.triggerFlickerAnimation();
        }
    };
    const disabled = hasCommonErrors || !actionStatus.canTakeAction;
    const helperText = errorHelperText || actionStatus.errorMessageIfCantTakeAction;
    const icon = CITY_WALL_IMAGE_PATH[myColor];
    const actionState = currentStateValidator.getPlayerActionState(myColor);
    const isPlacingCityWall = actionState === ActionState.PlaceCityWall && !disabled;
    var _cityWallValidator_getCityWallPlayerState_bankCityWallAmount;
    const bankCityWallAmount = (_cityWallValidator_getCityWallPlayerState_bankCityWallAmount = cityWallValidator === null || cityWallValidator === void 0 ? void 0 : cityWallValidator.getCityWallPlayerState(myColor).bankCityWallAmount) !== null && _cityWallValidator_getCityWallPlayerState_bankCityWallAmount !== void 0 ? _cityWallValidator_getCityWallPlayerState_bankCityWallAmount : 0;
    const onClick = ()=>{
        if (disabled) return;
        if (isPlacingCityWall) {
            sendClearCornerHighlight();
            sendCancelAction();
        } else {
            sendBuildCityWall();
        }
    };
    return /*#__PURE__*/ React.createElement(UIGameActionButton, {
        className: className,
        count: bankCityWallAmount,
        countColor: myColor,
        disabled: disabled,
        helperText: helperText,
        highlight: isPlacingCityWall,
        iconPath: icon,
        onClickActionIfDisabled: triggerFlickerCardsAnimation,
        tooltipCustomMenuComponent: /*#__PURE__*/ React.createElement(UIGameResourceCardsTooltipContent, {
            cardInventory: playerValidator.resourceCards.cards,
            cardsToBuild: cardsToBuildCityWall,
            ref: tooltipRef
        }),
        onClick: onClick
    });
};
